'use client';

import { preload } from 'react-dom';
import { useTranslation } from 'react-i18next';
import type { ReactNode } from 'react';

import ResponsiveLayout from '@/components/apps/layouts/responsive/Layout';
import About from '@/components/apps/pages/about/About';
import VisuallyHiddenPageTitle from '@/components/apps/ui/a11y/VisuallyHiddenPageTitle';

type Props = {
  newsSection: ReactNode;
  phoneNumber: ReactNode;
};

export default function AboutPageClient({ newsSection, phoneNumber }: Props) {
  const { t } = useTranslation('common');
  const title = t('회사소개');

  preload('/images/apps/about/subtop_bg_01_m.avif', {
    as: 'image',
    media: '(max-width: 991px)',
  });
  preload('/images/apps/about/subtop_bg_01.avif', {
    as: 'image',
    media: '(min-width: 992px)',
  });

  return (
    <>
      <VisuallyHiddenPageTitle>{title}</VisuallyHiddenPageTitle>
      <ResponsiveLayout mobilePadding={{ top: '0', bottom: '0' }}>
        <About newsSection={newsSection} phoneNumber={phoneNumber} />
      </ResponsiveLayout>
    </>
  );
}
